/* src/pages/tisversion/page-tisversion.component.scss */
:host {
  display: block;
}
.tis-category {
  margin-bottom: var(--vwui-size-spacing-lg);
}
.tis-subject {
  font-weight: 500;
}
.tis-col--nr {
  width: 2rem;
}
.tis-col--question {
  white-space: normal;
}
.tis-col--answer {
  width: 30%;
}
.tis-col--options {
  width: 1px;
  white-space: nowrap;
}
/*# sourceMappingURL=page-tisversion.component-GT4ERR42.css.map */
